import React from 'react';
import styles from './BaseModalContent.module.scss';

interface BaseModalContentProps {
    children: React.ReactNode;
    className?: string;
    padding?: 'none' | 'small' | 'medium' | 'large';
    scrollable?: boolean;
}

export const BaseModalContent: React.FC<BaseModalContentProps> = ({
    children,
    className,
    padding = 'medium',
    scrollable = true
}) => {
    const paddingClass = {
        none: styles.paddingNone,
        small: styles.paddingSmall,
        medium: styles.paddingMedium,
        large: styles.paddingLarge
    }[padding];

    const scrollClass = scrollable ? styles.scrollable : styles.noScroll;

    return (
        <div className={`
            ${styles.modalContent} 
            ${paddingClass} 
            ${scrollClass} 
            ${className || ''}
        `}>
            {children}
        </div>
    );
};

export default BaseModalContent;
